import { Typography, Stack, Link } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "./StandardDialog"
import { B_PACK_EXTENSION_URL } from "../../../modules/serviceCenter/report/external/brotherPrinter"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    notInstalledExtTitle: {
        fontSize: "1.5rem",
        fontWeight: 500,
        color: tailwindPalette.slate[950],
    },
    notInstalledExtMessage: {
        fontSize: "0.875rem",
        color: tailwindPalette.slate[950],
    },
    extensionLink: {
        color: tailwindPalette.sky[800],
        transition: "all ease-in-out 0.3s",
        cursor: "pointer",
        "&:hover": {
            color: tailwindPalette.sky[400],
        },
    },
}))

type LabelPrinterExtensionDialogProps = {
    open: boolean
    onClose: () => void
}

export function LabelPrinterExtensionDialog({ open, onClose }: LabelPrinterExtensionDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={open}
            dialogTitle={
                <LocalizedStrict id="service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-title">
                    <Typography className={classes.notInstalledExtTitle}>
                        Chrome label printer extension is not installed
                    </Typography>
                </LocalizedStrict>
            }
            onClose={onClose}
            maxWidthProp="sm"
            scroll="body"
        >
            <Stack alignItems="center" gap={1}>
                <LocalizedStrict id="service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-message">
                    <Typography className={classes.notInstalledExtMessage}>
                        To print labels, please install the Brother b-PAC Extension and reload page.
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict
                    id="service-center-reports-check-in-modal-guest-details-printer-not-installed-modal-cta-message"
                    elems={{
                        hereLink: (
                            <Link
                                href={B_PACK_EXTENSION_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.extensionLink}
                            ></Link>
                        ),
                    }}
                >
                    <Typography className={classes.notInstalledExtMessage}>
                        Click <Link>here</Link> to open Chrome web store where you can install the extension.
                    </Typography>
                </LocalizedStrict>
            </Stack>
        </StandardDialog>
    )
}

